import { createFileRoute } from '@tanstack/react-router';
import WantedBoss from '../../components/WantedBoss';

export const Route = createFileRoute('/events/wanted-boss')({
  component: () => <WantedBoss />,
});





